export class AccountService {

  constructor() {}

  /**
   * GET ACCOUNT ORDER DATA
   * @param customerid is the customer loading into account
   */
  getRetailOrders(customerId, hash) {
    return fetch(`/a/myaccount/orders?customer=${customerId}&hash=${hash}`)
      .then((response) => {
        if (response.ok) {
          return response.json()
        } else if(response.status === 404) {
          return []
        } else {
          throw new Error(response.status);
        }
      });
  }

  getCustomerOrders(customerId, hash, associateId) {
    const url = associateId ? `/a/myaccount/orders?associate=${associateId}&customer=${customerId}&hash=${hash}` : `/a/myaccount/orders?customer=${customerId}&hash=${hash}`
    console.log(`getCustomerOrders ${url}`)
    return fetch(url)
      .then((response) => {
        if (response.ok) {
          return response.json()
        } else if(response.status === 404) {
          return []
        } else {
          throw new Error(response.status);
        }
      });
  }

  returnsUrl(baseUrl, order) {
    if (!baseUrl) {
      console.error('Returns Base URL not set.');
    } else {
      return `${baseUrl}?email=${encodeURIComponent(order.email)}&order=${order.name?.replace("#", "")}`;
    }
  }

  inStoreReturnUrl(inStoreReturnUrl) {
    if (inStoreReturnUrl === '' || inStoreReturnUrl === undefined) return false;
    return `${inStoreReturnUrl}`;
  }

  displayReturnBtn(created_at, days) {
    if (!created_at) return false;

    let threshold = new Date(created_at);
    threshold.setDate(threshold.getDate() + days);
    threshold = new Date(threshold).getTime();
    const today = new Date().getTime();

    return threshold > today;
  }

  getFulfilledOrders(order) {
    if (order.fulfillment_status === 'unfulfilled') return [];
    const fulfilled = order.line_items;
    if (fulfilled.length === 0) return [];
    const fulfilledOrders = Object.values(fulfilled.reduce((result, {
        fulfillment_created_at,
        title,
        available,
        product_title,
        variant_title,
        variant_option1,
        variant_option2,
        variant_option3,
        product_type,
        image,
        price,
        url,
        product_id,
        quantity,
        fulfillment_status,
        fulfillment_tracking_number,
        fulfillment_tracking_url,
        fulfillment_tracking_company,
    }) => {
        // Create new group
      if (!result[fulfillment_created_at]) result[fulfillment_created_at] = {
        fulfillment_created_at,
        fulfillment: [],
      };
        // Append to group
      result[fulfillment_created_at].fulfillment.push({
        title,
        available,
        product_title,
        variant_title,
        variant_option1,
        variant_option2,
        variant_option3,
        product_type,
        image,
        price,
        url,
        product_id,
        quantity,
        fulfillment_status,
        fulfillment_tracking_number,
        fulfillment_tracking_url,
        fulfillment_tracking_company,
        fulfillment_created_at,
      });
      return result;
    }, {}));
    return fulfilledOrders;
  }
}
